export default "__VITE_ASSET__B8gr2Gcu__"